export const PREDEFINED_HABITS = [
  {
    name: 'Morning Reading',
    icon: 'BookOpen',
    category: 'Learning',
    color: '#3B82F6',
    description: 'Read for 20 minutes every morning',
    imageUrl: 'https://images.unsplash.com/photo-1632861116304-b27d2121a59b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYm9vayUyMGNvZmZlZSUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3Njk4NTU2NDV8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Daily Exercise',
    icon: 'Dumbbell',
    category: 'Fitness',
    color: '#F59E0B',
    description: 'Get moving for at least 30 minutes',
    imageUrl: 'https://images.unsplash.com/photo-1582898967731-b5834427fd66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxydW5uaW5nJTIwc2hvZXMlMjBtb3JuaW5nJTIwbGlnaHR8ZW58MHx8fHwxNzY5ODU1NjQ2fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Drink Water',
    icon: 'Droplets',
    category: 'Health',
    color: '#06B6D4',
    description: 'Stay hydrated with 8 glasses of water',
    imageUrl: 'https://images.unsplash.com/photo-1610821165540-80c084d50fd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMG9mJTIwd2F0ZXIlMjBzdW5saWdodCUyMG1pbmltYWxpc3R8ZW58MHx8fHwxNzY5ODU1NjYyfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Meditation',
    icon: 'Brain',
    category: 'Mindfulness',
    color: '#8B5CF6',
    description: 'Practice mindfulness for 10 minutes',
    imageUrl: 'https://images.unsplash.com/photo-1749138197883-79537895b020?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcGxhbnQlMjBwb3QlMjBncm93dGh8ZW58MHx8fHwxNzY5ODU1NjQwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Journal Writing',
    icon: 'PenLine',
    category: 'Reflection',
    color: '#EC4899',
    description: 'Write down your thoughts and gratitude',
    imageUrl: 'https://images.unsplash.com/photo-1632861116304-b27d2121a59b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYm9vayUyMGNvZmZlZSUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3Njk4NTU2NDV8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Learn Something New',
    icon: 'GraduationCap',
    category: 'Learning',
    color: '#10B981',
    description: 'Spend 30 minutes learning a new skill',
    imageUrl: 'https://images.unsplash.com/photo-1632861116304-b27d2121a59b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYm9vayUyMGNvZmZlZSUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3Njk4NTU2NDV8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Healthy Meal',
    icon: 'Apple',
    category: 'Nutrition',
    color: '#84CC16',
    description: 'Eat at least one nutritious meal',
    imageUrl: 'https://images.unsplash.com/photo-1610821165540-80c084d50fd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMG9mJTIwd2F0ZXIlMjBzdW5saWdodCUyMG1pbmltYWxpc3R8ZW58MHx8fHwxNzY5ODU1NjYyfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'No Social Media',
    icon: 'SmartphoneOff',
    category: 'Digital Detox',
    color: '#6366F1',
    description: 'Spend a day without social media',
    imageUrl: 'https://images.unsplash.com/photo-1749138197883-79537895b020?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcGxhbnQlMjBwb3QlMjBncm93dGh8ZW58MHx8fHwxNzY5ODU1NjQwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Practice Gratitude',
    icon: 'Heart',
    category: 'Mindfulness',
    color: '#EF4444',
    description: 'List 3 things you\'re grateful for',
    imageUrl: 'https://images.unsplash.com/photo-1632861116304-b27d2121a59b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYm9vayUyMGNvZmZlZSUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3Njk4NTU2NDV8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Sleep 8 Hours',
    icon: 'Moon',
    category: 'Rest',
    color: '#14B8A6',
    description: 'Get a full night of quality sleep',
    imageUrl: 'https://images.unsplash.com/photo-1749138197883-79537895b020?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcGxhbnQlMjBwb3QlMjBncm93dGh8ZW58MHx8fHwxNzY5ODU1NjQwfDA&ixlib=rb-4.1.0&q=85',
  },
];

export const HABIT_ICONS = [
  // Original icons
  'BookOpen', 'Dumbbell', 'Droplets', 'Brain', 'PenLine',
  'GraduationCap', 'Apple', 'SmartphoneOff', 'Heart', 'Moon',
  'Coffee', 'Music', 'Palette', 'Code', 'Camera',
  'Bike', 'TreePine', 'Sunrise', 'Star', 'Target',
  // Energy & Achievement
  'Zap', 'Trophy', 'Rocket', 'Flame', 'Sparkles',
  // Communication
  'MessageCircle', 'Phone', 'Mail', 'Gift', 'Cake',
  // Food
  'Pizza', 'Salad', 'Soup', 'Wine', 'IceCream',
  // Work & Entertainment
  'Briefcase', 'Laptop', 'Headphones', 'Gamepad', 'Film',
  // Nature
  'Mountain', 'Waves', 'Cloud', 'Sun', 'Umbrella',
  'Leaf', 'Flower', 'Butterfly', 'Dog', 'Cat',
  // Health & Fitness (NEW)
  'Activity', 'HeartPulse', 'Stethoscope', 'Pill', 'Thermometer',
  'Weight', 'Footprints', 'CircleDot', 'Timer', 'Smile',
  'Bed', 'Bath', 'Watch', 'Glasses', 'Wind',
  'Repeat', 'TrendingUp', 'CheckCircle', 'Calendar', 'Bell',
  'Utensils', 'Carrot', 'Fish', 'Egg', 'Beef',
  'Sandwich', 'Cookie', 'Cherry', 'Banana', 'Candy',
];

export const HABIT_COLORS = [
  '#3B82F6', // Blue
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#F59E0B', // Orange
  '#10B981', // Green
  '#14B8A6', // Teal
  '#F97316', // Dark Orange
  '#6366F1', // Indigo
  '#EF4444', // Red
  '#84CC16', // Lime
  '#06B6D4', // Cyan
  '#A855F7', // Violet
];
